import { render, staticRenderFns } from "./teacheraccounts.vue?vue&type=template&id=75d77512"
import script from "./teacheraccounts.ts?vue&type=script&lang=js&external"
export * from "./teacheraccounts.ts?vue&type=script&lang=js&external"
import style0 from "./teacheraccounts.vue?vue&type=style&index=0&id=75d77512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports